import React from 'react';
import { bool } from 'prop-types';
import { Placeholder } from '@thd-olt-component-react/core-ui';
import classNames from 'classnames';
import './fulfillmentPlaceholder.scss';

const FulfillmentPlaceholder = ({ isMajorAppliances }) => {
  const tileArray = [];
  const placeholderCss = classNames(
    { fulfillment__fullcontent: true },
    { 'fulfillment__placeholder-base': !isMajorAppliances },
    { 'fulfillment__placeholder-major-appliance': isMajorAppliances }
  );

  for (let i = 0; i < 2; i += 1) {
    tileArray.push(
      <div className="card card-container card-unselected card-disabled" key={i}>
        <div className="placeholder-container">
          <div className="card-head">
            <Placeholder type="text" height="20px" />
          </div>
          { new Array(2).fill('').map((value, index) => {
            return <Placeholder type="text" height="12px" width="90px" key={index} />;
          })}
          <div className="card-footer">
            <Placeholder type="text" height="15px" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fulfillment__placeholder" data-component="FulfillmentTilesPlaceholder">
      <div className="fulfillment__placeholder-wrapper card-deck">
        {tileArray}
      </div>
      <div className={placeholderCss} />
    </div>
  );
};

FulfillmentPlaceholder.propTypes = {
  isMajorAppliances: bool
};

FulfillmentPlaceholder.defaultProps = {
  isMajorAppliances: false
};

export { FulfillmentPlaceholder };
